/** Shared Brain File Uploads type guards — keep in sync with backend FILE_UPLOAD_*. */

export const FILE_UPLOAD_EXTENSIONS = ["pdf", "docx", "txt", "md"];

export const FILE_UPLOAD_ACCEPT = ".pdf,.docx,.txt,.md";

export const FILE_UPLOAD_FORMATS_LABEL = "PDF, DOCX, TXT, and Markdown";

export const FILE_UPLOAD_REJECT_MESSAGE =
  "Unsupported file type. Only PDF, DOCX, TXT, and Markdown files can be uploaded as Knowledge Sources.";

function fileExtension(filename = "") {
  const base = String(filename).split(/[/\\]/).pop() || "";
  const dot = base.lastIndexOf(".");
  if (dot <= 0) return "";
  return base.slice(dot + 1).toLowerCase();
}

export function isAllowedKnowledgeUploadFile(file) {
  if (!file || !file.name) return false;
  return FILE_UPLOAD_EXTENSIONS.includes(fileExtension(file.name));
}

/**
 * Split a FileList / File[] into accepted vs rejected by extension.
 * Does not read file contents (backend enforces signatures).
 */
export function partitionKnowledgeUploadFiles(files) {
  const list = Array.from(files || []);
  const accepted = [];
  const rejected = [];
  for (const file of list) {
    if (isAllowedKnowledgeUploadFile(file)) accepted.push(file);
    else rejected.push(file);
  }
  return { accepted, rejected };
}

export function knowledgeUploadRejectToast(rejected) {
  if (!rejected?.length) return FILE_UPLOAD_REJECT_MESSAGE;
  const names = rejected.slice(0, 3).map((f) => f.name).join(", ");
  const more = rejected.length > 3 ? ` (+${rejected.length - 3} more)` : "";
  return `${FILE_UPLOAD_REJECT_MESSAGE} Rejected: ${names}${more}`;
}
